import { render, staticRenderFns } from "./promotionContainerTab.vue?vue&type=template&id=7516f4fe&lang=pug"
import script from "./promotionContainerTab.vue?vue&type=script&lang=js"
export * from "./promotionContainerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports